/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AccountIsNumberOfEmployeesEnoughForOutOfBandQueryVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
}>;


export type AccountIsNumberOfEmployeesEnoughForOutOfBandQuery = { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly isNumberOfEmployeesEnoughForOutOfBand: boolean | null } | null };


export const AccountIsNumberOfEmployeesEnoughForOutOfBandDocument = gql`
    query AccountIsNumberOfEmployeesEnoughForOutOfBand($accountId: AccountId!) {
  account(id: $accountId) {
    id
    isNumberOfEmployeesEnoughForOutOfBand
  }
}
    `;

/**
 * __useAccountIsNumberOfEmployeesEnoughForOutOfBandQuery__
 *
 * To run a query within a React component, call `useAccountIsNumberOfEmployeesEnoughForOutOfBandQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountIsNumberOfEmployeesEnoughForOutOfBandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountIsNumberOfEmployeesEnoughForOutOfBandQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountIsNumberOfEmployeesEnoughForOutOfBandQuery(baseOptions: Apollo.QueryHookOptions<AccountIsNumberOfEmployeesEnoughForOutOfBandQuery, AccountIsNumberOfEmployeesEnoughForOutOfBandQueryVariables> & ({ variables: AccountIsNumberOfEmployeesEnoughForOutOfBandQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountIsNumberOfEmployeesEnoughForOutOfBandQuery, AccountIsNumberOfEmployeesEnoughForOutOfBandQueryVariables>(AccountIsNumberOfEmployeesEnoughForOutOfBandDocument, options);
      }
export function useAccountIsNumberOfEmployeesEnoughForOutOfBandLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountIsNumberOfEmployeesEnoughForOutOfBandQuery, AccountIsNumberOfEmployeesEnoughForOutOfBandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountIsNumberOfEmployeesEnoughForOutOfBandQuery, AccountIsNumberOfEmployeesEnoughForOutOfBandQueryVariables>(AccountIsNumberOfEmployeesEnoughForOutOfBandDocument, options);
        }
export function useAccountIsNumberOfEmployeesEnoughForOutOfBandSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountIsNumberOfEmployeesEnoughForOutOfBandQuery, AccountIsNumberOfEmployeesEnoughForOutOfBandQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountIsNumberOfEmployeesEnoughForOutOfBandQuery, AccountIsNumberOfEmployeesEnoughForOutOfBandQueryVariables>(AccountIsNumberOfEmployeesEnoughForOutOfBandDocument, options);
        }
export type AccountIsNumberOfEmployeesEnoughForOutOfBandQueryHookResult = ReturnType<typeof useAccountIsNumberOfEmployeesEnoughForOutOfBandQuery>;
export type AccountIsNumberOfEmployeesEnoughForOutOfBandLazyQueryHookResult = ReturnType<typeof useAccountIsNumberOfEmployeesEnoughForOutOfBandLazyQuery>;
export type AccountIsNumberOfEmployeesEnoughForOutOfBandSuspenseQueryHookResult = ReturnType<typeof useAccountIsNumberOfEmployeesEnoughForOutOfBandSuspenseQuery>;
export type AccountIsNumberOfEmployeesEnoughForOutOfBandQueryResult = Apollo.QueryResult<AccountIsNumberOfEmployeesEnoughForOutOfBandQuery, AccountIsNumberOfEmployeesEnoughForOutOfBandQueryVariables>;